<template>
  <v-dialog v-model="open" :persistent="persistent" :width="width">
    <v-card>
      <v-card-title>{{title}}</v-card-title>
      <v-card-text v-html="message"></v-card-text>
      <v-card-actions><v-btn color="primary" @click="open = false">Ok</v-btn></v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 600
    },
    persistent: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      message: "",
      title: "",
      open: false
    }
  },
  watch: {
    open: function (newValue) {
      if (!newValue) {
        this.message = '';
        this.title = ''
      }
    }
  },
  methods: {
    showMessage(title, message) {
      this.title = title;
      this.message = message;
      this.open = true;
    }
  },
}
</script>
